const formatStatus = (status) => status.replace(/_/g, ' ').toLowerCase()

export default formatStatus
